module.exports = __webpack_public_path__ + "img/profile-teal.6d6b6758.svg";